import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const getGstrClient = ({ queryKey }: any) => {
  return http.get("/gstr-client", { params: { ...queryKey[1] } });
};

const getGstrReportsClient = ({ queryKey }: any) => {
  return http.get("/gstr-client/reports", { params: { ...queryKey[1] } });
};

const exportGstrClient = (data: any) => {
  return cronHttp.post("/gstr-client/gstr-client-export", data);
};

const getAtomClients = ({ queryKey }: any) => {
  return http.get("/gstr-client/clients", { params: { ...queryKey[1] } });
};

const addGstrCredentials = (data: any) => {
  return http.post("/gstr-client/credentials", data);
};

const createGsrRequest = ({ id, data }: any) => {
  return http.post(`/gstr-client/gstr-request/${id}`, data);
};

const updateGstrCredentials = (data: any) => {
  return http.put(`/gstr-client/credentials/${data?.id}`, data?.data);
};

const bulkGstrSync = (data: any) => {
  return http.post(`/gstr-client/bulkSync`, data);
};

const getGstrActivity = ({ queryKey }: any) => {
  return http.get(`/gstr-client/activity/${queryKey[1]}`, { params: { ...queryKey[2] } });
};

const getGstrActivityArchive = ({ queryKey }: any) => {
  return http.get(`/gstr-client/activityArchive/${queryKey[1]}`, { params: { ...queryKey[2] } });
};

const getClientSyncStatus = ({ queryKey }: any) => {
  return http.get(`/gstr-client/syncStatus/${queryKey[1]}`);
};

const getGstrCaseIdsNotices = ({ queryKey }: any) => {
  return http.get(`/gstr-client/case-ids/`, { params: { ...queryKey[1] } });
};

const exportCasebasedOrgNotices = (data: any) => {
  return cronHttp.post("/gstr-client/gstr-casebased-export", data);
};

const getGstrPanGroups = ({ queryKey }: any) => {
  return http.get("/gstr-client/pan-groups", { params: { ...queryKey[1] } });
};

const getGstrPanGroupByPan = ({ queryKey }: any) => {
  return http.get(`/gstr-client/pan-groups/${encodeURIComponent(queryKey[1])}`);
};

export {
  getGstrClient,
  exportCasebasedOrgNotices,
  exportGstrClient,
  getAtomClients,
  addGstrCredentials,
  createGsrRequest,
  updateGstrCredentials,
  bulkGstrSync,
  getGstrActivity,
  getClientSyncStatus,
  getGstrCaseIdsNotices,
  getGstrActivityArchive,
  getGstrReportsClient,
  getGstrPanGroups,
  getGstrPanGroupByPan,
};
